import {
  Component, Input, HostBinding, AfterViewInit, NgZone, OnChanges, SimpleChanges, SimpleChange,  ChangeDetectionStrategy, OnDestroy, ChangeDetectorRef, ViewChild, OnInit
} from '@angular/core';
import {DataTable} from '../../base';
import {Subscription} from 'rxjs';
import {ScrollerComponent} from '../../../scroller';
import {RowGroupTemplateDirective} from '../../directives/row-group-template.directive';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';

@Component({
  selector: 'dt-body',
  templateUrl: './body.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BodyComponent implements OnInit, AfterViewInit, OnChanges, OnDestroy {
  bottomVal: string | null = null;
  totalWidth: string | null = null;
  customTotalWidth: string | null = null;
  fixedOrNot: boolean = true;
  @Input() scrollDisplay: boolean;

  @Input() table: DataTable;
  @Input() loading: boolean;
  @Input() rowGroupTemplate: RowGroupTemplateDirective;

  @HostBinding('class') cssClass = 'datatable-body';
  @ViewChild(ScrollerComponent, {static: true}) scroller: ScrollerComponent;

  private subscriptions: Subscription[] = [];
  rowTrackingFn = (index: number, row: any) => (this.table.settings.trackByProp) ? row[this.table.settings.trackByProp] : index;

  constructor(private cd: ChangeDetectorRef, private _ngZone: NgZone, private responsive: BreakpointObserver) { }

  ngOnInit(): void {
    //ngOnChanges(changes: SimpleChanges) {
    //console.log(this.table.settings.groupRowsBy == ["Device ID"])
    const subRows = this.table.events.rowsChanged$.subscribe(() => {
     this.cd.markForCheck();
    });
    const subFilter = this.table.events.filterSource$.subscribe(() => {
      this.cd.markForCheck();
    });

    const subColumnResizeEnd = this.table.events.resizeEndSource$.subscribe(() => {//IMP - For extra column dyn created in vqtpesq screen
      if (this.table.rsltType == 'VqtData') {
        const wrapperTable = document.getElementById('wrapper-table');
        //console.log(this.table.dimensions.columnsTotalWidth + '::' + wrapperTable.offsetWidth)
        this.totalWidth = (this.table.dimensions.columnsTotalWidth - (this.table.dimensions.columnsTotalWidth - wrapperTable.offsetWidth)).toString();
        this.customTotalWidth = this.table.dimensions.columnsTotalWidth.toString();
      }
    });
    
    this.subscriptions.push(subRows);
    this.subscriptions.push(subFilter);
    this.subscriptions.push(subColumnResizeEnd);
  }

  ngOnChanges(changes: SimpleChanges) {
    let currBottom = 8;//13
    //if (this.table.rsltType == 'NetTestData' || this.table.rsltType == 'MobileInfoData')
    //  currBottom = 4;
    //else if (this.table.rsltType == 'VacData')
    //  currBottom = 5;

    const wrapperTable = document.getElementById('wrapper-table');
    this.totalWidth = (this.table.dimensions.columnsTotalWidth - (this.table.dimensions.columnsTotalWidth - wrapperTable.offsetWidth)).toString();

    //console.log(this.table.dimensions.columnsTotalWidth)
    this.customTotalWidth = this.table.dimensions.columnsTotalWidth.toString();

    ////console.log(this.table.dimensions.bodyHeightOrig)
    //if (this.table.rsltType == 'VqtData')
    //  this.table.dimensions.bodyHeight = 98;
    //else if (this.table.rsltType == 'VqtPolqa')
    //  this.table.dimensions.bodyHeight = 98;
    //else if (this.table.rsltType == 'VquadData')
    //  this.table.dimensions.bodyHeight = 115;
    //else if (this.table.rsltType == 'AudioDelayData')
    //  this.table.dimensions.bodyHeight = 130;//320
    //else if (this.table.rsltType == 'FaxData')
    //  this.table.dimensions.bodyHeight = 150;
    //else if (this.table.rsltType == 'VbaData')
    //  this.table.dimensions.bodyHeight = 120;
    //else if (this.table.rsltType == 'NetTestData' || this.table.rsltType == 'MobileInfoData')
    //  this.table.dimensions.bodyHeight = 100;
    //else if (this.table.rsltType == 'VacData')
    //  this.table.dimensions.bodyHeight = 100;
    //else if (this.table.rsltType == 'EmuData')
    //  this.table.dimensions.bodyHeight = 90;

    if (this.table.rows.length > 0) {
      currBottom = 16;
      //this.table.dimensions.bodyHeight = this.table.dimensions.bodyHeightOrig;
      //if (this.table.rows.length < 20)
      //  this.table.dimensions.bodyHeight = (40 * this.table.rows.length) + 10;

      this.totalWidth = (this.table.dimensions.columnsTotalWidth - (this.table.dimensions.columnsTotalWidth - wrapperTable.offsetWidth) - 18).toString();
      this.customTotalWidth = (this.table.dimensions.columnsTotalWidth).toString();
    }
    this.bottomVal = currBottom.toString();
   


    this.responsive.observe([Breakpoints.Web, Breakpoints.WebLandscape, Breakpoints.WebPortrait,
    Breakpoints.Tablet, Breakpoints.TabletPortrait, Breakpoints.TabletLandscape,
    Breakpoints.Handset, Breakpoints.HandsetLandscape, Breakpoints.HandsetPortrait,
    Breakpoints.XSmall, Breakpoints.Small, Breakpoints.Medium, Breakpoints.Large, Breakpoints.XLarge
    ])
      .subscribe(result => {

        const breakpoints = result.breakpoints;
        if (breakpoints[Breakpoints.Tablet] || breakpoints[Breakpoints.TabletPortrait] || breakpoints[Breakpoints.TabletLandscape]
          || breakpoints[Breakpoints.Handset] || breakpoints[Breakpoints.HandsetPortrait] || breakpoints[Breakpoints.HandsetLandscape]
          || breakpoints[Breakpoints.XSmall] || breakpoints[Breakpoints.Small]) {
          this.scrollDisplay = true;
        }
        else if (breakpoints[Breakpoints.Medium]) //IPad Pro
          this.scrollDisplay = true;

        if (breakpoints[Breakpoints.XLarge]) {
          currBottom = 5;//8
          if (this.table.rows.length > 0)
            currBottom = 10.5;
          //if (this.table.rsltType == 'NetTestData' || this.table.rsltType == 'MobileInfoData')
          //  currBottom = 7;
          //else if (this.table.rsltType == 'VacData')
          //  currBottom = 10;

          //if (this.table.rsltType == 'VqtData')
          //  this.table.dimensions.bodyHeight = 50;
          //else if (this.table.rsltType == 'VqtPolqa')
          //  this.table.dimensions.bodyHeight = 50;
          //else if (this.table.rsltType == 'VquadData')
          //  this.table.dimensions.bodyHeight = 60;
          //else if (this.table.rsltType == 'AudioDelayData')
          //  this.table.dimensions.bodyHeight = 70;//320
          //else if (this.table.rsltType == 'FaxData')
          //  this.table.dimensions.bodyHeight = 90;
          //else if (this.table.rsltType == 'VbaData')
          //  this.table.dimensions.bodyHeight = 60;
          //else if (this.table.rsltType == 'NetTestData')
          //  this.table.dimensions.bodyHeight = 100;
          //else if (this.table.rsltType == 'MobileInfoData')
          //  this.table.dimensions.bodyHeight = 150;
          //else if (this.table.rsltType == 'VacData')
          //  this.table.dimensions.bodyHeight = 80;
          //else if (this.table.rsltType == 'EmuData')
          //  this.table.dimensions.bodyHeight = 40;

          if (this.table.rows.length > 0) {
            //this.table.dimensions.bodyHeight = this.table.dimensions.bodyHeightOrig;
            ////if (this.table.rows.length < 20) {
            ////  this.table.dimensions.bodyHeight = (40 * this.table.rows.length) + 10;
            ////  currBottom = this.table.rows.length < 10 ? (50 - (this.table.rows.length * 3)) : currBottom;
            ////}

            ////console.log(currBottom)
          }
          else {
            //currBottom = 50;
            //if (this.table.rsltType == 'NetTestData' || this.table.rsltType == 'MobileInfoData')
            //  currBottom = 25;
            //else if (this.table.rsltType == 'VacData')
            //  currBottom = 40;
          }
          this.bottomVal = currBottom.toString();
        }

        if (this.table.rsltType === undefined || this.table.requestID !== undefined) {
          this.fixedOrNot = false;
          if (this.table.requestID !== undefined)
            this.table.dimensions.bodyHeight = 100;
        }
      });
  }

  ngOnDestroy() {
    this.subscriptions.forEach(s => s.unsubscribe());
  }

  updatePage(direction: string) {
    if (this.table.settings.virtualScroll && direction && this.table.pager) {
      let page = this.scroller.start / this.scroller.itemsPerRow;
      page = Math.ceil(page) + 1;
      if (page !== this.table.pager.current) {
        this.table.pager.current = page;
        this.table.events.onPage();
      }
    }
  }

  onScroll(event: any) {
    this.table.dimensions.offsetY = event.scrollYPos;
    this.table.dimensions.offsetX = event.scrollXPos;
    this.table.events.onScroll(event);
    if (event.direction) {
      this.updatePage(event.direction);
    }
    this.cd.markForCheck();
  }


  //For Call Timestamp grouping, Maps config Device ID - IMP
  onExpand(row: any) {
    row.expanded = !row.expanded;
    if (!row.expanded) {
      const descendants = this.table.rowGroup.getGroupRows(row, this.table.rows);
      descendants.forEach(x => x.$$height = 0);
    } else {
      const descendants = this.table.rowGroup.getGroupRows(row, this.table.rows);
      descendants.forEach(x => x.$$height = null);
    }
  }

  getExpanderIcon(row: any) {
    return (!row.expanded) ? 'dt-icon-node dt-icon-collapsed' : 'dt-icon-node';
  }


  ngAfterViewInit() {
    if (this.table.rsltType !== undefined && this.table.requestID === undefined)
      this._listenOnScroll();
  }
  _listenOnScroll() {
    this._ngZone.runOutsideAngular(() => {
      const wrapperScroll = document.getElementById('wrapper-scroll');
      const wrapperTable = document.getElementById('wrapper-table');
      wrapperScroll.onscroll = () => {
        wrapperTable.scrollLeft = wrapperScroll.scrollLeft;
      };
      wrapperTable.onscroll = () => {
        wrapperScroll.scrollLeft = wrapperTable.scrollLeft;
      };
    });
  }
}
